module.exports = __webpack_public_path__ + "img/pap.8101fc51.svg";